import { /*Map,*/ fromJS } from "immutable";
import { handleActions, createAction } from "redux-actions";
import Restful from "lib/restful";
import { getImgUrl } from "lib/imageUrlHelper";

const EXP_MINUTE = 30;

const EXPORT_USER_PROFILE = "userProfile/EXPORT_USER_PROFILE";
const SET_IS_LOADING_OF_OTHERS = "userProfile/SET_IS_LOADING_OF_OTHERS";
const SET_USER_PROFILE = "userProfile/SET_USER_PROFILE";
const SET_USERS_EXPIRATION_DATE = "userProfile/SET_USERS_EXPIRATION_DATE";
const EDIT_FOLLOWER_NUM = "userProfile/EDIT_FOLLOWER_NUM";
const EDIT_MY_FOLLOWING_NUM = "userProfile/EDIT_MY_FOLLOWING_NUM";
const SET_IS_FOLLOWING = "userProfile/SET_IS_FOLLOWING";
const SET_MY_GENDER_FILLED = "userProfile/SET_MY_GENDER_FILLED";
const SET_STATUS = "userProfile/SET_STATUS";
const SET_MY_PROFILE = "userProfile/SET_MY_PROFILE";
const SET_MY_EXPIRATION_DATE = "userProfile/SET_MY_EXPIRATION_DATE";
const INIT_ALL_DATA = "userProfile/INIT_ALL_DATA";

const exportUserProfile = createAction(EXPORT_USER_PROFILE);
const setIsLoadingOfOthers = createAction(SET_IS_LOADING_OF_OTHERS);
const setUserProfile = createAction(SET_USER_PROFILE);
const setUsersExpirationDate = createAction(SET_USERS_EXPIRATION_DATE);
const editFollowerNum = createAction(EDIT_FOLLOWER_NUM);
const editMyFollowingNum = createAction(EDIT_MY_FOLLOWING_NUM);
const setIsFollowing = createAction(SET_IS_FOLLOWING);
const setMyGenderFilled = createAction(SET_MY_GENDER_FILLED);
const setStatus = createAction(SET_STATUS);
const setMyProfile = createAction(SET_MY_PROFILE);
const setMyExpirationDate = createAction(SET_MY_EXPIRATION_DATE);
const initAllData = createAction(INIT_ALL_DATA);

const getUserProfileState = ({ getState }) => {
  const userProfileState = getState().userProfile.toJS();
  return userProfileState;
};

const getTargetData = ({ getState, name }) => {
  const userProfileState = getUserProfileState({ getState });
  const { data } = userProfileState;
  return data[name];
};

const getHasLoggedIn = ({ getState }) => {
  const { myAccount } = getState();
  const { hasLoggedIn } = myAccount.toJS();
  return hasLoggedIn;
};

const checkIsLoadingOfOthers = ({ getState, name }) => {
  const targetData = getTargetData({ getState, name });
  const isLoading = !!targetData && targetData.isLoading;
  return { isLoading };
};

const checkExpDate = ({ getState, type, name }) => {
  let expirationDate;
  switch (type) {
    case "other":
      const targetData = getTargetData({ getState, name });
      expirationDate = targetData && targetData.expirationDate;
      break;
    case "mine":
    default:
      const userProfileState = getUserProfileState({ getState });
      const { myProfile } = userProfileState;
      expirationDate = myProfile && myProfile.expirationDate;
      break;
  }
  if (!expirationDate) return { needUpdate: true };
  const nowDate = new Date();
  return { needUpdate: nowDate > expirationDate ? true : false };
};

const setExpDate = ({ dispatch, type, name }) => {
  const expirationDate = new Date();
  expirationDate.setMinutes(expirationDate.getMinutes() + EXP_MINUTE);
  switch (type) {
    case "other":
      dispatch(setUsersExpirationDate({ name, expirationDate }));
      break;
    case "mine":
    default:
      dispatch(setMyExpirationDate(expirationDate));
      break;
  }
};

const saveDataOfMyProfile = ({
  dispatch,
  image,
  followingNum,
  location,
  gender,
  preset
}) => {
  /**
   * 팔로워숫자 기록기능 구현했지만 현재 사용하지 않는 상태.
   * 백엔드에서 followerNum 값 전달한다면 바로 사용가능
   * 만일 "followerNum 필요하지 않다고 확정"되면 하단값 저장객체 제거하자.
   * */
  dispatch(
    setMyProfile({
      image,
      followingNum,
      followerNum: 0,
      location,
      gender,
      preset
    })
  );
  const myGenderFilled = !!gender ? "genderSet" : "genderUnset";
  dispatch(setMyGenderFilled(myGenderFilled));
};

const requestMyProfile = async ({ dispatch, idToken }) => {
  const { code, res, errInfo } = await Restful.getMyProfileAPI({ idToken });
  if (code === "error") {
    const errObj = Error("api error");
    errObj.errorValue = { ...errInfo };
    throw errObj;
  } else if (code === "UserDoesNotExist") {
    return { success: false };
  }
  const {
    email,
    username,
    image,
    followingNum,
    location,
    gender,
    birthday,
    gaUserId,
    isEmailAuthUser,
    isGoogleAuthUser,
    preset
  } = res;

  saveDataOfMyProfile({
    dispatch,
    image,
    followingNum,
    location,
    gender,
    preset
  });

  return {
    success: true,
    email,
    username,
    location,
    gender,
    birthday,
    gaUserId,
    isEmailAuthUser,
    isGoogleAuthUser
  };
};

const requestProfile = async ({ name }) => {
  const { code, res, errInfo } = await Restful.getOthersProfileAPI(name);
  if (code === "UnknownUser") {
    return { notExist: true };
  } else if (code === "error") {
    const errObj = Error("api error");
    errObj.errorValue = { ...errInfo };
    throw errObj;
  } else {
    /**
     * 팔로워숫자 기록기능 구현했지만 현재 사용하지 않는 상태.
     * 백엔드에서 followerNum 값 전달한다면 바로 사용가능
     * 만일 "followerNum 필요하지 않다고 확정"되면 하단값 저장객체 제거하자.
     * */
    const { image, location, gender, preset } = res;
    return { image, followerNum: 0, location, gender, preset };
  }
};

const requestRelationship = async ({ name, getState, idToken }) => {
  const hasLoggedIn = getHasLoggedIn({ getState });

  if (!hasLoggedIn) return { isFollowing: "no" };

  const { code, res, errInfo } = await Restful.checkRelationshipAPI({
    target: name,
    idToken
  });
  if (code === "error") {
    const errObj = Error("api error");
    errObj.errorValue = { ...errInfo };
    throw errObj;
  } else {
    const isFollowing = Number(res.follow) === 1 ? "yes" : "no";
    return { isFollowing };
  }
};

export const changeUserProfile =
  ({ name, idToken }) =>
  async (dispatch, getState) => {
    const { isLoading } = checkIsLoadingOfOthers({ getState, name });
    if (isLoading) return { isExist: true };

    const { needUpdate } = checkExpDate({ getState, type: "other", name });

    if (!needUpdate) {
      dispatch(exportUserProfile(name));
      return { isExist: true };
    }

    dispatch(setIsLoadingOfOthers({ name, isLoading: true }));

    const [userProfileObj, relationshipObj] = await Promise.all([
      requestProfile({ name }),
      requestRelationship({ name, getState, idToken })
    ]);

    const { notExist, image, followerNum, location, gender, preset } =
      userProfileObj;
    const { isFollowing } = relationshipObj;

    if (notExist) {
      dispatch(setIsLoadingOfOthers({ name, isLoading: false }));
      return { isExist: false };
    }

    dispatch(
      setUserProfile({
        name,
        image,
        followerNum,
        location,
        gender,
        isFollowing,
        preset
      })
    );
    setExpDate({ dispatch, type: "other", name });
    dispatch(exportUserProfile(name));

    dispatch(setIsLoadingOfOthers({ name, isLoading: false }));
    return { isExist: true };
  };

export const changeRelation =
  ({ name, idToken }) =>
  async (dispatch, getState) => {
    const targetData = getTargetData({ getState, name });
    const { isFollowing } = targetData;

    if (isFollowing === "pending") return null;
    dispatch(setIsFollowing({ name, isFollowing: "pending" }));

    switch (isFollowing) {
      case "yes":
        const { code: code1, errInfo: errInfo1 } =
          await Restful.breakRelationshipAPI({
            target: name,
            idToken
          });
        if (code1 === "error") {
          dispatch(setIsFollowing({ name, isFollowing: "yes" }));
          const errObj = Error("api error");
          errObj.errorValue = { ...errInfo1 };
          throw errObj;
        }
        dispatch(editFollowerNum({ name, offset: -1 }));
        dispatch(editMyFollowingNum({ offset: -1 }));
        dispatch(setIsFollowing({ name, isFollowing: "no" }));
        break;
      case "no":
        const { code, errInfo } = await Restful.makeRelationshipAPI({
          target: name,
          idToken
        });
        if (code === "error") {
          dispatch(setIsFollowing({ name, isFollowing: "no" }));
          const errObj = Error("api error");
          errObj.errorValue = { ...errInfo };
          throw errObj;
        } else if (code === "UnknownUser") {
          dispatch(setIsFollowing({ name, isFollowing: "no" }));
          const errObj = Error("UnknownUser");
          errObj.errorValue = { name };
          throw errObj;
        } else if (code === "CantFollowYourself") {
          dispatch(setIsFollowing({ name, isFollowing: "no" }));
          const errObj = Error("CantFollowYourself");
          errObj.errorValue = { name };
          throw errObj;
        } else if (code === "ExceededFollowCount") {
          dispatch(setIsFollowing({ name, isFollowing: "no" }));
          const errObj = Error("ExceededFollowCount");
          errObj.errorValue = { name };
          throw errObj;
        } else if (code === "DeletedUser") {
          dispatch(setIsFollowing({ name, isFollowing: "no" }));
          const errObj = Error("DeletedUser");
          errObj.errorValue = { name };
          throw errObj;
        }
        dispatch(editFollowerNum({ name, offset: 1 }));
        dispatch(editMyFollowingNum({ offset: 1 }));
        dispatch(setIsFollowing({ name, isFollowing: "yes" }));
        break;
      default:
        break;
    }

    dispatch(exportUserProfile(name));
  };

export const initMyProfile =
  (idToken, forLogIn = false) =>
  async (dispatch, getState) => {
    const userProfileState = getUserProfileState({ getState });
    const { myProfile } = userProfileState;
    const { status } = myProfile;
    const { needUpdate } = checkExpDate({ getState, type: "mine" });

    try {
      if (forLogIn || needUpdate || status === "ready") {
        dispatch(setStatus("pending"));
        const {
          success,
          email,
          username,
          location,
          gender,
          birthday,
          gaUserId,
          isEmailAuthUser,
          isGoogleAuthUser
        } = await requestMyProfile({
          dispatch,
          idToken
        });

        if (success) {
          setExpDate({ dispatch, type: "mine" });
          dispatch(setStatus("success"));

          return {
            success,
            email,
            username,
            gaUserId,
            location,
            gender,
            birthday,
            isEmailAuthUser,
            isGoogleAuthUser
          };
        } else {
          dispatch(setStatus("ready"));
          return { success };
        }
      }
      return {};
    } catch (error) {
      dispatch(setStatus("ready"));
      throw error;
    }
  };

export const uploadProfileImg =
  ({ filename, idToken }) =>
  async (dispatch, getState) => {
    const { code, errInfo } = await Restful.setProfileImageAPI({
      idToken,
      data: { file: filename }
    });
    if (code === "error") {
      const errObj = Error("api error");
      errObj.errorValue = { ...errInfo };
      throw errObj;
    }
  };

export const registerMyGender =
  ({ selectedGender, idToken }) =>
  async (dispatch, getState) => {
    const { code, res, errInfo } = await Restful.editMyInfoAPI({
      idToken,
      data: { gender: selectedGender }
    });
    if (code === "error") {
      const errObj = Error("api error");
      errObj.errorValue = { ...errInfo };
      throw errObj;
    }
    const { image, followingNum, location, gender, preset } = res;

    saveDataOfMyProfile({
      dispatch,
      image,
      followingNum,
      location,
      gender,
      preset
    });
  };

export const applyItemOpenPreset =
  ({ isItemListPublic, idToken }) =>
  async (dispatch, getState) => {
    const { code, res, errInfo } = await Restful.editMyPresetAPI({
      idToken,
      data: { isItemListPublic }
    });
    if (code === "error") {
      const errObj = Error("api error");
      errObj.errorValue = { ...errInfo };
      throw errObj;
    }
    const { image, followingNum, location, gender, preset } = res;

    saveDataOfMyProfile({
      dispatch,
      image,
      followingNum,
      location,
      gender,
      preset
    });
  };

export const deleteMyProfile = () => (dispatch, getState) => {
  dispatch(setStatus("ready"));
};

export const deleteAllData = () => (dispatch, getState) => {
  dispatch(initAllData());
};

const initialState = fromJS({
  data: {},
  /*
  data 의 구조.
  data: {
    [user's name]: {
      image: null,
      followerNum: 0,
      location: "location",
      gender: "gender",
      isFollowing: "pending",
      preset: null, // { isItemListPublic: true }
      expirationDate: null
    }
  },
  */
  image: null,
  followerNum: 0, // 현재 의미없는값 저장되고 있다. 조만간 삭제예정
  location: "empty",
  gender: "empty",
  preset: null, // { isItemListPublic: true }
  isFollowing: "pending", // "yes","no","pending"

  myGenderFilled: "pending", // "genderSet","genderUnset","pending"

  myProfile: {
    status: "ready", // "ready","pending","success"
    image: null,
    followingNum: 0,
    followerNum: 0, // 현재 의미없는값 저장되고 있다. 조만간 삭제예정
    location: "empty",
    gender: "empty",
    preset: null, // { isItemListPublic: true }
    expirationDate: null
  }
});

export default handleActions(
  {
    [EXPORT_USER_PROFILE]: (state, action) => {
      const name = action.payload;
      const { data } = state.toJS();
      const { image, followerNum, location, gender, isFollowing, preset } =
        data[name];
      return state
        .set("image", fromJS(image))
        .set("followerNum", fromJS(followerNum))
        .set("location", fromJS(location))
        .set("gender", fromJS(gender))
        .set("isFollowing", fromJS(isFollowing))
        .set("preset", fromJS(preset));
    },
    [SET_IS_LOADING_OF_OTHERS]: (state, action) => {
      const { name, isLoading } = action.payload;
      return state.setIn(["data", name, "isLoading"], fromJS(isLoading));
    },
    [SET_USER_PROFILE]: (state, action) => {
      const {
        name,
        image,
        followerNum,
        location,
        gender,
        isFollowing,
        preset
      } = action.payload;
      const { data } = state.toJS();
      const oldData = data[name];
      const userProfile = {
        ...oldData,
        image: getImgUrl("profile", image),
        followerNum,
        location,
        gender,
        isFollowing,
        preset
      };
      return state.setIn(["data", name], fromJS(userProfile));
    },
    [SET_USERS_EXPIRATION_DATE]: (state, action) => {
      const { name, expirationDate } = action.payload;
      return state.setIn(
        ["data", name, "expirationDate"],
        fromJS(expirationDate)
      );
    },
    [EDIT_FOLLOWER_NUM]: (state, action) => {
      const { name, offset } = action.payload;
      const { data } = state.toJS();
      const { followerNum } = data[name];
      const value = followerNum + offset;
      return state.setIn(["data", name, "followerNum"], fromJS(value));
    },
    [EDIT_MY_FOLLOWING_NUM]: (state, action) => {
      const { offset } = action.payload;
      const { myProfile } = state.toJS();
      const { status, followingNum } = myProfile;
      if (status === "success") {
        const newFollowingNum = followingNum + offset;
        return state.setIn(
          ["myProfile", "followingNum"],
          fromJS(newFollowingNum)
        );
      } else {
        return state;
      }
    },
    [SET_IS_FOLLOWING]: (state, action) => {
      const { name, isFollowing } = action.payload;
      return state.setIn(["data", name, "isFollowing"], fromJS(isFollowing));
    },
    [SET_MY_GENDER_FILLED]: (state, action) => {
      const myGenderFilled = action.payload;
      return state.set("myGenderFilled", fromJS(myGenderFilled));
    },
    [SET_STATUS]: (state, action) => {
      const status = action.payload;
      return state.setIn(["myProfile", "status"], fromJS(status));
    },
    [SET_MY_PROFILE]: (state, action) => {
      const { image, followingNum, followerNum, location, gender, preset } =
        action.payload;
      const { myProfile } = state.toJS();
      const myNewProfile = {
        ...myProfile,
        image: getImgUrl("profile", image),
        followingNum,
        followerNum,
        location,
        gender,
        preset
      };
      return state.set("myProfile", fromJS(myNewProfile));
    },
    [SET_MY_EXPIRATION_DATE]: (state, action) => {
      const expirationDate = action.payload;
      return state.setIn(
        ["myProfile", "expirationDate"],
        fromJS(expirationDate)
      );
    },
    [INIT_ALL_DATA]: (state, action) => {
      return initialState;
    }
  },
  initialState
);
